import { createSlice } from "@reduxjs/toolkit";
import { contactCenterNumberTable } from "../../../constants/interface/contactCenterNumber";

import { CONTACT_CENTER_NUMBER } from "../../../constants/reducer_names";

const initialState: contactCenterNumberTable = {
  isLoading: false,
  contactNumberList: [] as any,
  isUpdated: false,
  didList: [] as any,
  apidata: [] as any,
  isModalVisible: false,
};
const contactCenterNumberSlice = createSlice({
  name: CONTACT_CENTER_NUMBER,
  initialState,
  reducers: {
    contactCenterNumber: (state, { payload }) => {
      state.contactNumberList = payload.contactNumberList;
      state.didList = payload.didList;
    },

    updateNumber: (state, { payload }) => {
      state.contactNumberList = payload.contactNumberList;
      state.didList = payload.didList;
    },
    apivalue: (state, { payload }) => {
      state.apidata = payload.apidata;
    },
    showPopup: (state) => {
      state.isModalVisible = true;
    },
    handleOk: (state) => {
      state.isModalVisible = false;
    },
    handleCancel: (state) => {
      state.isModalVisible = false;
    },
    reset: () => {},
  },
});
export const contactCenterNumberActions = contactCenterNumberSlice.actions;
export default contactCenterNumberSlice.reducer;
